<template>
  <base-dialog class="edit-sub-dialog" width="800px" :visible.sync="visible">
    <template #header>
      <div class="header-wrap">
        <span class="title">编辑 {{ control.name }}_{{ curIdx + 1 }}</span>
        <el-tooltip content="上一条" :disabled="first">
          <svg-icon
            :class="['prev-btn', first ? 'disabled' : '']"
            icon-class="detail_menu-open"
            @click.native="submit('prev')"
          ></svg-icon>
        </el-tooltip>
        <el-tooltip content="下一条" :disabled="last">
          <svg-icon
            :class="['next-btn', last ? 'disabled' : '']"
            icon-class="detail_menu-open"
            @click.native="submit('next')"
          ></svg-icon>
        </el-tooltip>
      </div>
    </template>
    <div v-loading="loading" class="main-wrap">
      <form-group
        ref="formGroup"
        v-if="visible"
        :groups="controlGroup"
        width-level="2"
        :sheetDataServer="sheetDataServer"
        :form-util="formUtil"
        @update="handleFieldUpdate"
      ></form-group>
    </div>
    <template #footer>
      <base-button type="primary" @click="submit">保存</base-button>
      <base-button @click="visible = false">取消</base-button>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/UIComponents/BaseDialog"
import FormGroup from "@/components/Sheet/SheetForm/FormGroup"
import BaseButton from "@/components/UIComponents/Button"
import FormUtil from "@/components/Sheet/EditDialog/FormUtil"
export default {
  name: "edit-sub-dialog",
  components: { BaseButton, FormGroup, BaseDialog },
  props: {
    availableSheets: Array,
    control: Object,
    fillControlMap: Object,
    disabledAll: Boolean,
    first: Boolean,
    last: Boolean,
    curIdx: Number
  },
  provide() {
    return { status: this.status, rootFormVm: this }
  },
  data() {
    return {
      visible: false,
      loading: false,
      form: {},
      controlGroup: [],
      status: { initial: true },
      calcSheetDataServerDebounced: null,
      sheetDataServer: {}
    }
  },
  created() {
    this.calcSheetDataServerDebounced = this._.debounce(this.calcSheetDataServer, 500)
  },
  methods: {
    open(form, formUtil) {
      this.form = this._.cloneDeep(form)
      this.formUtil = new FormUtil({
        dataId: formUtil.dataId,
        sheetInfo: formUtil.sheetInfo,
        availableSheets: formUtil.availableSheets,
        snStep: formUtil.snStep,
        formGetterFunc: () => this.form,
        updateFormFunc: ({ updateObj, initFromGroup = false }) => {
          this.form = Object.assign({}, this.form, updateObj)
          this.calcSheetDataServerDebounced()
          initFromGroup && this.$refs.formGroup?.init(this.form, Object.keys(updateObj))
        }
      })
      this.visible = true
      this.initForm(formUtil.sheetInfo)
      this.formUtil.sheetDefUpdateCbk = sheetInfo => {
        if (!this.visible) return false
        this.initForm(sheetInfo)
      }
      this.calcSheetDataServerDebounced()
    },
    initForm(sheetInfo) {
      let controlGroup = []
      for (let group of sheetInfo?.layout?.groupList || []) {
        let controls = group.cidList
          .filter(cid => this.fillControlMap[cid])
          .map(cid => {
            let control = this.formUtil.controlMap[cid]
            let fillControl = this.fillControlMap[cid]
            return Object.assign({}, control, {
              required: fillControl.required || control.required,
              disabled: fillControl.disabled || control.disabled || this.disabledAll
            })
          })
        if (controls.length > 0) controlGroup.push({ name: group.name, controls })
      }
      this.controlGroup = controlGroup
      this.$nextTick(() => this.$refs.formGroup.init(this.form))
    },
    // 处理 form 分组中的某个字段值发生变化
    handleFieldUpdate(cid, data) {
      this.status.initial = false
      this.formUtil.handleFieldUpdate({
        form: this.form,
        updateObj: { [cid]: data }
      })
      this.calcSheetDataServerDebounced()
    },
    calcSheetDataServer() {
      this.sheetDataServer = this.formUtil.getSheetDataServer(this.form, this.dataId)
    },
    submit(type) {
      switch (type) {
        case "prev":
          if (this.first) return
          this.$emit("submit", this.form)
          this.$emit("prev")
          break
        case "next":
          if (this.last) return
          this.$emit("submit", this.form)
          this.$emit("next")
          break
        default:
          this.$emit("submit", this.form)
          this.visible = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.edit-sub-dialog {
  ::v-deep {
    .el-dialog {
      .el-dialog__body {
        flex: 1;
        padding: 0;
        height: 0;
      }
    }
  }
  .header-wrap {
    display: flex;
    align-items: center;
    .title {
      margin-right: 12px;
    }
    .prev-btn {
      margin-right: 6px;
      cursor: pointer;
      color: white;
      background: #1989fa;
      border-radius: 4px;
      transform: rotate(90deg);
      &.disabled {
        color: #c0c4cc;
        background: #f5f7fa;
        cursor: not-allowed;
      }
    }
    .next-btn {
      cursor: pointer;
      color: white;
      background: #1989fa;
      border-radius: 4px;
      transform: rotate(-90deg);
      &.disabled {
        color: #c0c4cc;
        background: #f5f7fa;
        cursor: not-allowed;
      }
    }
  }
  .main-wrap {
    padding: 30px 20px 30px 44px;
    box-sizing: border-box;
  }
}
</style>
